import React from "react";

const getRoleLabel = (role) => {
  if (role === "Staff") return "Nhân viên";
  if (role === "Manager") return "Quản lý";
  return "Cộng tác viên";
};

const HomeMobileHeader = ({
  user = {},
  notificationCount = 0,
  onToggleNotification,
  onOpenMenu,
}) => {
  const displayName =
    user.fullName || user.username || user.companyName || "Tài khoản";

  return (
    <header className="relative z-0 h-[132px] overflow-hidden bg-[#0155F8] px-5 pb-9 pt-8 text-white shadow-[0_12px_28px_rgba(1,85,248,0.22)] md:hidden">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-10 -top-7 h-20 w-20 rounded-full bg-white/10" />
        <div className="absolute left-[56%] top-8 size-5 -translate-x-1/2 rounded-full border-[5px] border-white/10" />
        <div className="absolute -right-16 -top-20 size-44 rounded-full border-[30px] border-white/10" />
        <div className="absolute -left-14 bottom-2 size-24 rounded-full border-[24px] border-white/10" />
      </div>

      <div className="relative z-10 flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <img
            src={user.avatar || "/images/avatar-default.png"}
            alt=""
            className="size-[46px] shrink-0 rounded-full border-2 border-[#FFDC13] bg-white object-cover shadow-md"
            loading="lazy"
          />
          <div className="min-w-0">
            <p
              className="max-w-[180px] truncate font-sf-semibold text-[16px] leading-5 text-[#FFDC13]"
              title={displayName}
            >
              {displayName}
            </p>
            <p className="mt-0.5 font-be-vietnam-light text-xs leading-4 text-white/90">
              {getRoleLabel(user.role)}
            </p>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <div className="relative">
            <button
              type="button"
              className="flex size-10 items-center justify-center rounded-full transition-colors hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
              onClick={onToggleNotification}
              aria-label="Mở thông báo"
            >
              <img src="/icons/ring.svg" alt="" className="size-6" />
            </button>
            {notificationCount ? (
              <span className="absolute right-0 top-0 flex h-4 min-w-4 items-center justify-center rounded-full border border-white bg-red-600 px-1 text-[9px] leading-none text-white">
                {notificationCount > 99 ? "99+" : notificationCount}
              </span>
            ) : null}
          </div>

          <button
            type="button"
            onClick={onOpenMenu}
            className="flex size-10 items-center justify-center rounded-full transition-colors hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
            aria-label="Mở menu"
          >
            <img
              src="/icons/menu.svg"
              alt=""
              className="size-7 brightness-0 invert"
            />
          </button>
        </div>
      </div>
    </header>
  );
};

export default HomeMobileHeader;
